export default {"src":"/_next/static/media/shift4shop.0617a305.svg","height":63,"width":500,"blurWidth":0,"blurHeight":0};